import { HELP_CENTRE_LOCALISED_URL } from '@seek/shared-constants';
import { useTranslations } from '@vocab/react';
import {
  Box,
  Text,
  Heading,
  IconChevron,
  Stack,
  Button,
  Actions,
} from 'braid-design-system';

import { TextLink } from 'src/components';
import { TRACKING_CODES } from 'src/shared/constant';
import { useConfig } from 'src/shared/hooks';

import translations from './.vocab';

interface ThanksViewProps {
  setSubmitted: (submitted: boolean) => void;
}
const ThanksView = ({ setSubmitted }: ThanksViewProps) => {
  const { site, siteLanguage } = useConfig();
  const { t } = useTranslations(translations);

  return (
    <Box>
      <Stack space="medium">
        <Heading level="3">{t('Thanks for contacting us')}</Heading>
        <Text>{t('We’ll try to reply to your enquiry')}</Text>
        <Text>{t('If you need to speak to us urgently')}</Text>
        <Text>
          {t('You can also search for answers', {
            TextLink: (children) => (
              <TextLink
                // @ts-ignore
                href={HELP_CENTRE_LOCALISED_URL[site][siteLanguage]}
                tracking={TRACKING_CODES.content_element_pressed}
                trackingProps={{ elementDesign: 'link' }}
                product="other"
              >
                {children}
              </TextLink>
            ),
          })}
        </Text>
        <Actions>
          <Button onClick={() => setSubmitted(false)} variant="soft">
            <IconChevron direction="left" /> {t('Back to Contact Us page')}
          </Button>
        </Actions>
      </Stack>
    </Box>
  );
};

export default ThanksView;
